import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import ContentLoaderPlaceholder from '@wtag/rcl-content-loader-placeholder';
import './styles.scss';

const FlightRoute = ({ originInfo, destinationInfo, styleVariant }) => {
  const isRouteDataAvailable =
    Object.keys(originInfo).length > 0 && Object.keys(destinationInfo).length > 0;

  if (!isRouteDataAvailable) {
    return (
      <ContentLoaderPlaceholder
        numberOfLines={1}
        showBackground={false}
        isRounded={false}
        contentWidth="260px"
      />
    );
  }

  return (
    <div
      className={classNames('flight-route', {
        'flight-route--bold-large': styleVariant === 'boldLarge',
        'flight-route--light-small': styleVariant === 'lightSmall',
      })}
    >
      {I18n.t('components.ibe.cart_item.journey_summary', {
        origin_city: originInfo.placeName,
        origin_country: originInfo.countryName,
        destination_city: destinationInfo.placeName,
        destination_country: destinationInfo.countryName,
      })}
    </div>
  );
};

FlightRoute.defaultProps = {
  originInfo: {},
  destinationInfo: {},
  styleVariant: 'lightSmall',
};

FlightRoute.propTypes = {
  originInfo: PropTypes.shape({ placeName: PropTypes.string, countryName: PropTypes.string }),
  destinationInfo: PropTypes.shape({ placeName: PropTypes.string, countryName: PropTypes.string }),
  styleVariant: PropTypes.oneOf(['boldLarge', 'lightSmall']),
};

export default FlightRoute;
